// @flow
import React from 'react';
import {
  compose,
  withProps,
  setDisplayName,
  onlyUpdateForKeys,
} from 'recompose';
import reactCSS from 'reactcss';
import Domain from './domain';
import { getStyles } from '@ux/style-utils';
import { gu2px } from '@ux/theme-utils';
import * as r from 'ramda';

export const stylesheet = ({
  theme,
}) => ({
  default: {
    root: {
      width: '100%',
      marginBottom: gu2px(1, theme.spacing),
    },
    domain: {
      marginBottom: gu2px(1, theme.spacing),
    },
  },
  isMinMd: {
    domain: {
      borderBottomWidth: 1,
    },
  },
});

// eslint-disable-next-line no-shadow
export const stylesheetToStyles = (stylesheet, {
  isMinMd,
}) => reactCSS(stylesheet, {
  isMinMd,
});

const hasDomains = r.pipe(
  r.prop('domains'),
  r.length,
  r.gt(r.__, 0),
);

export const PureDomainList = r.ifElse(
  hasDomains,
  ({
    theme,
    domains,
    styles,
    canTransfer,
    canBackorder,
    canNegotiate,
    currency,
    isMinSm,
    isMinMd,
    isMinLg,
    onPurchaseDomainClick,
    onTransferDomainClick,
    onBackorderDomainClick,
    onNegotiateDomainClick,
    onViewBasketClick,
  }) => (
    <div style={styles.root}>
      {r.map((domain) => (
        <div
          key={domain.fqdn}
          style={styles.domain}
        >
          <Domain
            domain={domain}
            theme={theme}
            currency={currency}
            intlNamespace={'standardDomains'}
            isMinMd={isMinMd}
            isMinLg={isMinLg}
            isMinSm={isMinSm}
            canTransfer={canTransfer}
            canBackorder={canBackorder}
            canNegotiate={canNegotiate}
            onViewBasketClick={onViewBasketClick}
            onTransferDomainClick={onTransferDomainClick}
            onBackorderDomainClick={onBackorderDomainClick}
            onNegotiateDomainClick={onNegotiateDomainClick}
            onPurchaseDomainClick={onPurchaseDomainClick}
          />
        </div>
      ), domains)}
    </div>
  ),
  r.always(null)
);

export const enhance = compose(
  setDisplayName('DomainList'),
  onlyUpdateForKeys([
    'theme',
    'domains',
    'currency',
    'isMinSm',
    'isMinMd',
    'isMinLg',
    'onPurchaseDomainClick',
  ]),
  withProps((ownerProps) => ({
    styles: getStyles(stylesheet, stylesheetToStyles, ownerProps),
  })),
);

export default enhance(PureDomainList);
